export const useDevDetect = () => {
    return (window as any).REACT_APP_DEV_MODE === "true";
};
